import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient from '@core/api/client'

export const resellerService = {
	getResellers(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/resellers', config)
	},
}

export default resellerService
